import { render, staticRenderFns } from "./carousel-brands-brand-cmp.vue?vue&type=template&id=b9c97a8c&scoped=true"
import script from "./carousel-brands-brand-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-brands-brand-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-brands-brand-cmp.vue?vue&type=style&index=0&id=b9c97a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c97a8c",
  null
  
)

export default component.exports